/* istanbul ignore file */

import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { Filter } from '../components/Filter';
import { actions as filterActions } from '../modules/slice';

const mapStateToProps = ({ filter: { filterModal }, products }: ReduxApplicationState) => ({
  isModalOpen: filterModal.isModalOpen,
  error: products.error,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeFilterModal: () => dispatch(filterActions.closeModal()),
  onShowList: () => dispatch(filterActions.showList()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FilterContainerProps = ConnectedProps<typeof connector>;

export const FilterContainer = connector(Filter);
